import './slick';
import './navigation';

(function(jQuery, Drupal) {
  'use strict';
})(jQuery, Drupal);
